var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunicate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill_Outline",
    "data-name": "Fill Outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 22h40a4 4 0 0 1 4 4v29a0 0 0 0 1 0 0h-48a0 0 0 0 1 0 0v-29a4 4 0 0 1 4-4z",
    fill: "#e9f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 38v-16h-22a4 4 0 0 0 -4 4v28h48z",
    fill: "#d0d8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 53v4a4 4 0 0 1 -4 4h-50a4 4 0 0 1 -4-4v-4h23v2h12v-2z",
    fill: "#93999a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.87 58a3.992 3.992 0 0 1 -3.87 3h-50a4 4 0 0 1 -4-4v-4h5v1a4 4 0 0 0 4 4z",
    fill: "#656b76"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ef5350",
    height: 16,
    rx: 2,
    width: 18,
    x: 39,
    y: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 22v1a2.006 2.006 0 0 1 -2 2h-14a2.006 2.006 0 0 1 -2-2v-12a2.006 2.006 0 0 1 2-2h1v1a12 12 0 0 0 12 12z",
    fill: "#e53935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 14h6v6h-6z",
    fill: "#ffea00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 20-4-2v-2l4-2z",
    fill: "#ffea00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 18v2h-6v-6h2v1a3 3 0 0 0 3 3z",
    fill: "#ffd000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 18.5v1.5l-4-2v-2l1.03-.52a3.224 3.224 0 0 0 1.76 2.41z",
    fill: "#ffd000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.37 20h-4.37v-5.19a12.073 12.073 0 0 0 4.37 5.19z",
    fill: "#ffb700"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ade8f4",
    height: 24,
    rx: 4,
    width: 28,
    x: 3,
    y: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 36v1a4 4 0 0 1 -4 4h-20a4 4 0 0 1 -4-4v-16a4 4 0 0 1 4-4h3v3a16 16 0 0 0 16 16z",
    fill: "#48cae4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 21h-8a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h4l4 4v-4a2 2 0 0 0 2-2v-4a2 2 0 0 0 -2-2z",
    fill: "#ff7373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 26v1a2.006 2.006 0 0 1 -2 2v4l-4-4h-4a2.006 2.006 0 0 1 -2-2v-4a2.006 2.006 0 0 1 2-2h1.09a5.99 5.99 0 0 0 5.91 5z",
    fill: "#ef5350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 25h8a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-4l-4 4v-4a2 2 0 0 1 -2-2v-4a2 2 0 0 1 2-2z",
    fill: "#ffea00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 31a2.006 2.006 0 0 1 -2 2h-4l-4 4v-4a2.006 2.006 0 0 1 -2-2v-4a2.006 2.006 0 0 1 2-2h3.08a6.979 6.979 0 0 0 6.92 6z",
    fill: "#ffd000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.66 33h-3.66l-4 4v-4a2.006 2.006 0 0 1 -2-2v-4a2.006 2.006 0 0 1 2-2h1.8a15.992 15.992 0 0 0 5.86 8z",
    fill: "#ffb700"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 41,
    fill: "#ade8f4",
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.61 46.61a11.7 11.7 0 0 1 -2.12 2.88 12.007 12.007 0 0 1 -16.98-16.98 11.7 11.7 0 0 1 2.88-2.12 12 12 0 0 0 16.22 16.22z",
    fill: "#48cae4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.6 44.182a2.428 2.428 0 0 0 -2.483-.587l-1.647.55a2 2 0 0 1 -2.047-.483l-1.081-1.081a2 2 0 0 1 -.483-2.047l.55-1.647a2.428 2.428 0 0 0 -.587-2.483 2.425 2.425 0 0 0 -3.923.712 7.276 7.276 0 0 0 1.479 8.157l1.353 1.353a7.276 7.276 0 0 0 8.157 1.479 2.425 2.425 0 0 0 .712-3.923z",
    fill: "#ffea00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.14 47.97a2.148 2.148 0 0 1 -.26.14 7.283 7.283 0 0 1 -8.15-1.48l-1.36-1.36a7.292 7.292 0 0 1 -2.13-5.15 7.21 7.21 0 0 1 .65-3 2.148 2.148 0 0 1 .14-.26 11.983 11.983 0 0 0 11.11 11.11z",
    fill: "#ffd000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 3h14v10h-14z",
    fill: "#ffd000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 11-6-8h14z",
    fill: "#ffb700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 11v2h-14v-10h2v2a6 6 0 0 0 6 6z",
    fill: "#ffb700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 9-7-6h14z",
    fill: "#ffea00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 9-7-6h5a5.117 5.117 0 0 0 1.236 5.236z",
    fill: "#ffd000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.417 52.746a1.9 1.9 0 0 1 -2.208-.224l-3.709-3.289 3.464-2 2.762 2.45a1.9 1.9 0 0 1 -.309 3.063z",
    fill: "#ffd000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.42 52.75a1.918 1.918 0 0 1 -2.21-.23l-3.71-3.29 3.46-2 1.16 1.02-2.02.48-.55.32 1.66 1.47a1.918 1.918 0 0 0 2.21.23 1.791 1.791 0 0 0 .66-.65 1.9 1.9 0 0 1 -.66 2.65z",
    fill: "#ffb700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 43.635h3a0 0 0 0 1 0 0v6a0 0 0 0 1 0 0h-3a3 3 0 0 1 -3-3 3 3 0 0 1 3-3z",
    fill: "#ff7373",
    transform: "matrix(.866 -.5 .5 .866 -21.308 13.748)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.259 45.331-10.16 2.402-3-5.196 7.16-7.598z",
    fill: "#ffea00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.26 45.33-10.16 2.4-3-5.19 1.78-1.89a8.058 8.058 0 0 0 8.06 2.7l1.92-.45z",
    fill: "#ffd000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.1 47.73-2.6 1.5a2.992 2.992 0 0 1 -4.5-2.58 2.852 2.852 0 0 1 .18-1 2.377 2.377 0 0 0 .22.49 3 3 0 0 0 4.1 1.09l.98-.56-2.13-3.7.75-.43z",
    fill: "#ef5350"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Outline_copy",
    fill: "#323232",
    "data-name": "Outline copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61 52h-5.09a12.933 12.933 0 0 0 5.267-15.527 1 1 0 0 0 -1.875.7 10.984 10.984 0 1 1 -2.524-3.946c.248.248.478.507.7.771a1 1 0 0 0 1.537-1.279c-.259-.311-.53-.615-.821-.906a12.951 12.951 0 0 0 -1.194-1.048v-5.545a2.985 2.985 0 0 0 1-2.22v-12a3 3 0 0 0 -3-3h-3a1 1 0 0 0 0 2h3a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1-1v-12a1 1 0 0 1 1-1h7a1 1 0 0 0 0-2h-7a3 3 0 0 0 -3 3v10h-6a5.006 5.006 0 0 0 -5-5h-20a5.006 5.006 0 0 0 -5 5v1a1 1 0 0 0 2 0v-1a3 3 0 0 1 3-3h20a3 3 0 0 1 3 3v16a2.993 2.993 0 0 1 -2.683 2.968l-3.192-5.529a1 1 0 0 0 -1.594-.186l-5.416 5.747h-10.115a3 3 0 0 1 -3-3v-11a1 1 0 0 0 -2 0v11a5.006 5.006 0 0 0 5 5v10h-4a1 1 0 0 0 -1 1v4a5.006 5.006 0 0 0 5 5h5a1 1 0 0 0 0-2h-5a3 3 0 0 1 -3-3v-3h21v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1h21v3a3 3 0 0 1 -3 3h-41a1 1 0 0 0 0 2h41a5.006 5.006 0 0 0 5-5v-4a1 1 0 0 0 -1-1zm-37.936-15.4 4.657 8.064-8.128 1.922-2.256-3.907zm-1 13.829a.9.9 0 0 1 -.146 1.448.9.9 0 0 1 -1.045-.106l-2.673-2.365 1.27-.733.48-.114zm-6.332-6.529 1 1.732 1 1.732-1.731 1a2 2 0 1 1 -2.001-3.464zm-6.732-1.9h6.029l-2.029 1.171a4 4 0 0 0 .964 7.328 4.038 4.038 0 0 0 1.042.138 3.951 3.951 0 0 0 1.308-.231l1.799 1.594h-9.113zm29 10a1 1 0 0 0 -1 1v1h-10v-1a1 1 0 0 0 -1-1h-1.783a3.044 3.044 0 0 0 .134-.606 2.87 2.87 0 0 0 -.96-2.459l-1.058-.935 7.156-1.692a1 1 0 0 0 .636-1.473l-1.758-3.046a4.991 4.991 0 0 0 3.633-4.789v-14h6a3 3 0 0 0 3 3h14v3.469a12.993 12.993 0 0 0 -12.91 22.531z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 13a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-.382l2.553 1.282a1 1 0 0 0 1.447-.9v-6a1 1 0 0 0 -1.447-.895l-2.553 1.277v-.382a1 1 0 0 0 -1-1zm5 6h-4v-4h4zm4-3.382v2.764l-2-1v-.764z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 27v4a3.006 3.006 0 0 0 2 2.829v3.171a1 1 0 0 0 1.707.707l3.707-3.707h3.586a3 3 0 0 0 3-3v-1h.586l3.707 3.707a1 1 0 0 0 1.707-.707v-3.171a3.006 3.006 0 0 0 2-2.829v-4a3 3 0 0 0 -3-3h-8a3 3 0 0 0 -3 3v1h-5a3 3 0 0 0 -3 3zm10-4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1 1 1 0 0 0 -1 1v1.586l-2.293-2.293a1 1 0 0 0 -.707-.293h-1v-1a3 3 0 0 0 -3-3h-1zm-8 4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 0 -.707.293l-2.293 2.293v-1.586a1 1 0 0 0 -1-1 1 1 0 0 1 -1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 22a1 1 0 0 0 0-2h-3a1 1 0 0 0 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.353 39.2a3.426 3.426 0 0 0 -6.369-2.5 8.315 8.315 0 0 0 1.683 9.278l1.353 1.353a8.312 8.312 0 0 0 9.28 1.685 3.426 3.426 0 0 0 -2.5-6.37l-1.648.55a.994.994 0 0 1 -1.023-.241l-1.08-1.081a.992.992 0 0 1 -.241-1.023zm2.429 5.889 1.648-.549a1.426 1.426 0 0 1 1.04 2.66 6.306 6.306 0 0 1 -7.036-1.276l-1.353-1.353a6.307 6.307 0 0 1 -1.276-7.036 1.409 1.409 0 0 1 1.044-.814 1.552 1.552 0 0 1 .261-.023 1.426 1.426 0 0 1 1.345 1.878l-.549 1.648a2.983 2.983 0 0 0 .726 3.069l1.08 1.08a2.978 2.978 0 0 0 3.07.72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.707 39.293a1 1 0 0 1 1 1 1 1 0 0 0 2 0 3 3 0 0 0 -3-3 1 1 0 0 0 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.707 40.293a7.008 7.008 0 0 0 -7-7 1 1 0 0 0 0 2 5.006 5.006 0 0 1 5 5 1 1 0 0 0 2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 14h14a1 1 0 0 0 1-1v-10a1 1 0 0 0 -1-1h-14a1 1 0 0 0 -1 1v10a1 1 0 0 0 1 1zm1-2v-6.826l5.35 4.585a1 1 0 0 0 1.3 0l5.35-4.585v6.826zm1.7-8h8.6l-4.3 3.683z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicate);
export default __webpack_public_path__ + "static/media/communicate.cf7d191a1eb08723b5c6b17642616a2f.svg";
export { ForwardRef as ReactComponent };